import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clearIcon from '../../../images/clear-field-icon.png';
import saveIcon from '../../../images/save-to-cloud-default.png';
import editIconActive from '../../../images/insight360/edit-icon_active.png';
import { toastWarning } from '../../../util/toastUtils';
import { SC_PACKAGE } from '../../../constants';

class InlineEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInEditMode: this.props.editMode !== undefined && this.props.editMode === 'on',
      isSaveInProgress: false,
      label: this.props.textVal !== undefined ? this.props.textVal : '',
      isError: false,
      index: this.props.index !== undefined ? this.props.index : -1,
      defaultModeEdit: this.props.editMode !== undefined && this.props.editMode === 'on',
      editButtonsDisplay: this.props.renderEditViewOnStart, // Default Edit Screen
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.textVal !== nextProps.textVal) {
      this.setState(
        {
          label: nextProps.textVal,
        },
        () => {
          this.changeEditModeVal(false);
        },
      );
    }
  }

  changeEditModeVal = argVal => {
    if (this.state.defaultModeEdit) {
      if (argVal === 'clearText') {
        this.editTextVal.value = '';
        this.setState({
          editButtonsDisplay: false,
        });
      } else {
        this.editTextVal.value = this.state.label;
        this.showEditButtons();
      }
    } else {
      this.setState({
        isInEditMode:
          argVal !== undefined && typeof argVal === 'boolean'
            ? argVal
            : !this.state.isInEditMode,
        isError: false,
        editButtonsDisplay: true,
      }, () => {
        if (typeof (this.props.editFunction) !== 'undefined') {
          this.props.editFunction(this.state.isInEditMode);
        }
        // Default Edit Screen
        if (typeof (this.props.toggleEditModefromParent) !== 'undefined') {
          this.props.toggleEditModefromParent('', 0, '', false);
        }
      });
    }
  };

  setNewLabel = () => {
    this.setState({ isSaveInProgress: true });
    this.props.updateFn(
      this.editTextVal.value,
      response => {
        this.setState({ isSaveInProgress: false });
        if (response && this.state.defaultModeEdit) {
          this.changeEditModeVal();
        }
        if (!response) {
          this.showErrorWarning();
        }
      },
      this.state.index,
    );
  };

  showErrorWarning = errorMsg => {
    if (errorMsg !== undefined) {
      toastWarning(errorMsg);
    }
    this.setState({
      isError: true,
    });
  };

  updatedEditContentVal = () => {
    const { defaultSection } = this.props;
    if (defaultSection && defaultSection === _.toLower(SC_PACKAGE)) {
      this.updatedEditContentValSC();
    } else if (
      this.editTextVal.value &&
      this.editTextVal.value !== this.state.label
    ) {
      if (typeof this.props.validateFn !== 'undefined') {
        this.props.validateFn(this.editTextVal.value, (...response) => {
          if (response[0] === true) {
            this.setNewLabel();
          } else {
            this.showErrorWarning(response[1]);
          }
        });
      } else {
        this.setNewLabel();
      }
    } else {
      this.changeEditModeVal();
    }
  }

  updatedEditContentValSC = () => {
    if (
      this.editTextVal.value) {
      if (typeof this.props.validateFn !== 'undefined') {
        this.props.validateFn(this.editTextVal.value, (...response) => {
          if (response[0] === true) {
            this.setNewLabel();
          } else {
            this.showErrorWarning(response[1]);
          }
        });
      } else {
        this.setNewLabel();
      }
    }
  }

  showEditButtons = () => {
    if ((this.props.editMode === undefined || this.props.editMode !== 'on') || (this.editTextVal && this.editTextVal.value.length > 0)) {
      this.setState({
        editButtonsDisplay: true,
      });
    } else {
      this.setState({
        editButtonsDisplay: false,
      });
    }
  }

  renderEditView() {
    return (
      <div
        className={`inlineEditBlockContainer ${this.props.editViewClass !== undefined ? this.props.editViewClass : ''}`}
        style={{
          width: this.props.editBlockWidth ? this.props.editBlockWidth : 'auto',
          marginTop: this.props.editBlockTopMargin ? this.props.editBlockTopMargin : '0%',
        }}
      >
        <div
          className={`inlineEditBlockContent ${
            this.state.isError ? 'show-error' : ''
            }`}
        >
          <input
            type="input"
            className="inlineEditBlockText"
            disabled={this.state.isSaveInProgress || this.props.disabled === 'disabled'}
            ref={node => (this.editTextVal = node)}
            defaultValue={this.state.label}
            onFocus={() => this.setState({ isError: false })}
            onChange={() => this.showEditButtons()}
            placeholder={this.props.placeholder !== undefined ? this.props.placeholder : ''}
          />
          {this.state.editButtonsDisplay && <span className="inlineEditBlockBtn">
            {!this.state.isSaveInProgress && <button type="button" onClick={() => this.changeEditModeVal('clearText')}>
              <img
                className="creator_edit_icons_img"
                style={{ height: '22px !important' }}
                src={clearIcon}
                alt="edit"
              />
            </button>}
            <button
              type="button"
              className="inline-edit-save-btn"
              style={{
                visibility: this.state.isSaveInProgress ? 'hidden' : 'inherit',
              }}
              onClick={this.updatedEditContentVal}
            >
              <img className="creator_edit_icons_img" src={saveIcon} alt="" />
            </button>
            {this.state.isSaveInProgress && (
              <span className="Select-loading-zone inline-edit-loading">
                <span className="Select-loading" />
              </span>
            )}
          </span>}
        </div>
      </div>
    );
  }

  renderDefaultView() {
    const { hideEditOption } = this.props;
    return (
      <div
        className="inline_edit_label_container"
        style={{
          maxWidth: this.props.defaultViewWidth,
        }}
      >
        <span
          data-tooltip
          aria-haspopup="true"
          className={`inline_edit_label ${
            this.props.labelClass ? this.props.labelClass : ''
            }`}
          title={this.state.label}
        >
          {this.state.label}
        </span>
        {!hideEditOption && <span className="inline-edit-icon-el">
          <img
            className="i360_header_edit_icons_img"
            onClick={this.changeEditModeVal}
            src={
              this.props.icon !== undefined && this.props.icon !== ''
                ? this.props.icon
                : editIconActive
            }
            alt="edit"
          />
        </span>}
      </div>
    );
  }

  render() {
    return (this.state.isInEditMode || this.props.renderEditViewOnStart)
      ? this.renderEditView()
      : this.renderDefaultView();
  }
}


InlineEdit.defaultProps = {
  defaultViewWidth: '100%',
  hideEditOption: false,
  renderEditViewOnStart: false,
};

InlineEdit.propTypes = {
  textVal: PropTypes.string,
  editBlockWidth: PropTypes.string,
  icon: PropTypes.string,
  updateFn: PropTypes.func,
  validateFn: PropTypes.func,
  labelClass: PropTypes.string,
  editMode: PropTypes.string,
  placeholder: PropTypes.string,
  editViewClass: PropTypes.string,
  editBlockTopMargin: PropTypes.string,
  editFunction: PropTypes.func,
  defaultViewWidth: PropTypes.string,
  hideEditOption: PropTypes.bool,
  renderEditViewOnStart: PropTypes.bool,
  toggleEditModefromParent: PropTypes.func,
  defaultSection: PropTypes.string,
};

export default InlineEdit;
